const nearestlocation = [
  { id:1,  near_name:"Temple"                  },
  { id:2,  near_name:"Metro Station"           },
  { id:3,  near_name:"Bus Stop"                },
  { id:4,  near_name:"Railway Station"         },
  { id:5,  near_name:"Airport"                 },
  { id:6,  near_name:"Hospital"               },
  { id:7,  near_name:"School"                  },
  { id:8,  near_name:"College"                 },
  { id:9,  near_name:"Mall / Shopping Center"  },
  { id:10, near_name:"Supermarket"             },
  { id:11, near_name:"IT Park / Tech Hub"      },
  { id:12, near_name:"Petrol Bunk"             },
];
export default nearestlocation;